<template>
  <div>
    <a
      v-if="localIsFavorite"
      class="icon"
      href="#"
      @click.prevent="unfavorite"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="19"
        height="18"
        viewBox="0 0 19 18"
      >
        <path
          fill="#064BC3"
          fill-rule="evenodd"
          d="M4.186 11.56l-.923 5.308a.963.963 0 0 0 .215.793.964.964 0 0 0 1.167.231l4.855-2.52 4.854 2.52a.955.955 0 0 0 1.168-.232.963.963 0 0 0 .214-.792l-.922-5.309 3.889-3.742a.963.963 0 0 0 .248-1.001.953.953 0 0 0-.775-.652l-5.391-.773L10.356.53a.955.955 0 0 0-1.712 0L6.215 5.39l-5.391.773a.953.953 0 0 0-.775.652.963.963 0 0 0 .248 1l3.889 3.744z"
        />
      </svg>
    </a>
    <a
      v-else
      href="#"
      @click.prevent="favorite"
    >
      <svg
        width="21px"
        height="20px"
        viewBox="0 0 21 20"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          id="Symbols"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
        >
          <g
            id="Icon----Star---isOpen"
            fill="none"
            transform="translate(1.000000, 1.000000)"
            stroke="#231F20"
          >
            <path
              id="Shape-Copy-7"
              d="M3.26328332,16.8683478 C3.21341175,17.154 3.29178136,17.4427826 3.47781022,17.6611304 C3.76279061,17.9953043 4.25200695,18.0954783 4.64543821,17.892 L9.49960419,15.372 L14.3537702,17.892 C14.4923023,17.964 14.6403338,18 14.7931149,18 C15.0725541,18 15.3377441,17.8763478 15.5213982,17.6603478 C15.707427,17.442 15.7857966,17.1532174 15.7359251,16.8675652 L14.8136969,11.5591304 L18.7028876,7.81669565 C18.9728273,7.55608696 19.0678208,7.1726087 18.9506622,6.81573913 C18.8358784,6.46591304 18.5390239,6.21547826 18.1764655,6.16382609 L12.7847948,5.3906087 L10.3561286,0.531391304 C10.1914733,0.203478261 9.86295419,0 9.49960419,0 C9.1362542,0 8.80773514,0.203478261 8.64387141,0.530608696 L6.21520519,5.3906087 L0.823534531,6.16382609 C0.460976146,6.21547826 0.164121572,6.46591304 0.0493378039,6.81573913 C-0.067820801,7.1733913 0.0271726624,7.55686957 0.297112421,7.81669565 L4.18551153,11.559913 L3.26328332,16.8683478 Z"
            />
          </g>
        </g>
      </svg>
    </a>
  </div>
</template>

<script type="text/babel">
export default {
  name: 'DocumentFavorite',
  props: {
    isFavorite: {
      type: Boolean,
      required: true,
    },
    document: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      localIsFavorite: false,
    }
  },
  async mounted() {
    await this.$nextTick()

    this.localIsFavorite = this.isFavorite
  },
  methods: {
    favorite() {
      this.loading = true

      this.$api.active().post(`documents/${this.document.uuid}/favorite`)
        .then(() => {
          this.loading = false
          this.localIsFavorite = true
        })
    },
    unfavorite() {
      this.loading = true

      this.$api.active().post(`documents/${this.document.uuid}/unfavorite`)
        .then(() => {
          this.loading = false
          this.localIsFavorite = false
        })
    },
  },
}
</script>
